import { rem } from '@mantine/core'

export default {
  none: '0',
  xs: rem(8),
  sm: rem(12),
  md: rem(16),
  lg: rem(20),
  xl: rem(24),
  '2xl': rem(40),
  '3xl': rem(56),
  '4xl': rem(72),
  '5xl': rem(96),
  '6xl': rem(120)
}
